import { createFileRoute } from '@tanstack/react-router';
import { PageErroInterno } from '@/features/painel-administrativo/erro/PageErroInterno';

export const Route = createFileRoute('/admin/_a/erro')({
    component: PageErroInterno,
});
